import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import produce from "immer";

export const createReducer = (
  initialState: any,
  handlers: { [type: string]: (state: any, action: any) => any },
) => {
  return function reducer(state = initialState, action: ReduxAction<any>) {
    if (action.type in handlers) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
};

export const createImmerReducer = (
  initialState: any,
  handlers: { [type: string]: any },
) => {
  return function reducer(state = initialState, action: ReduxAction<any>) {
    if (action.type in handlers) {
      return produce(handlers[action.type])(state, action);
    } else {
      return state;
    }
  };
};
